import React, { useState } from 'react';
import { MdEdit } from 'react-icons/md';
import { HeadingWithCreateBtn, Loader, Search, Table } from 'src/components';
import CrudIcon from 'src/components/crud-icon';
import { DashboardLayout } from 'src/containers';
import AddEmployee from './crud/AddEmployee';
import { useDispatch } from 'react-redux';
import { useSelector } from 'react-redux';
import { RootState } from 'src/redux/reducers';
import { fetchEmployee } from 'src/redux/action/employee.action';
import { AiOutlinePlus } from 'react-icons/ai';
import Button from 'src/components/button';
import useFetch from 'src/hooks/useFetch';

interface IProps {}

const EmployeeList: React.FC<IProps> = ({}) => {
  const [showModal, setShowModal] = React.useState(true);
  const [query, setQuery] = React.useState('');
  const [isEdit, setIsEdit] = React.useState(false);
  const [editId, setEditId] = React.useState('');
  const [editEmployeeData, setEditEmployeeData] = React.useState([]);
  const { employeeData, loading, error } = useSelector(
    ({ employeeData }: RootState) => employeeData
  );
  const [isHidden, setIsHidden] = React.useState(true);
  const [token, setToken] = useState('');

  const generateRandomDigits = (e: any) => {
    e.preventDefault();
    const randomDigits = [];
    for (let i = 0; i < 5; i++) {
      const randomDigit = Math.floor(Math.random() * 10);
      randomDigits.push(randomDigit);
    }
    setToken(randomDigits.join(''));
  };
  const dispatch = useDispatch();
  React.useEffect(() => {
    if (employeeData.length > 0) return;
    dispatch(fetchEmployee() as any);
  }, [dispatch]);

  const searchEmployeeData = employeeData?.filter((item) => {
    if (query === '') {
      return item;
    } else if (
      item?.employeeInfo?.name?.toLowerCase().includes(query.toLowerCase())
    ) {
      return item;
    }
  });

  const handleAddModal = () => {
    setToken('');
    setIsEdit(false);
    setEditId('');
    setShowModal(false);
    setTimeout(() => {
      setShowModal(true);
    }, 100);
    setEditEmployeeData([]);
  };

  const handleModal = () => {
    setShowModal(!showModal);
  };

  const handleEdit = (data: any) => {
    setEditEmployeeData(data);
    setIsEdit(true);
    setEditId(data.id);

    setIsHidden(false);
    setShowModal(false);
    setTimeout(() => {
      setShowModal(true);
    }, 100);
  };

  const {
    data: itemsData,
    fetchData,
    isLoading,
    errorText,
  } = useFetch('/employees');

  // table column
  const tableColumn = [
    {
      Header: 'Employee Name',
      Cell: (row: any) => (
        <div className="flex items-center space-x-2">
          {/* <img
            src={row?.cell?.row?.original?.image}
            alt="employee-photo"
            className="w-8 h-8 rounded-full object-cover"
          /> */}
          <div className="capitalize w-6 h-6 rounded-full bg-[black] text-[white]  text-md   flex items-center justify-center">
            {row.cell.row.original.name[0]}
          </div>
          <p className="text-text-black">
            {row?.cell?.row?.original?.name?.length > 8
              ? `${row?.cell?.row?.original?.name?.slice(0, 6)}..`
              : row?.cell?.row?.original?.name}
          </p>
        </div>
      ),
    },

    { Header: 'Email Address', accessor: 'email' },
    { Header: 'Contact', accessor: 'phone' },
    {
      Header: 'Designation',
      accessor: 'designation.title',
    },
    {
      Header: 'Action',

      Cell: (row: any) => (
        <CrudIcon
          fetchData={fetchEmployee() as any}
          url="/employees/remove"
          data={row?.cell?.row?.original}
        >
          <div
            className="w-7 h-7 rounded-xl bg-light-grey bg-opacity-50 flex items-center justify-center"
            onClick={() => handleEdit(row?.cell?.row?.original)}
          >
            <MdEdit color="#4062FF" />
          </div>
        </CrudIcon>
      ),
    },
  ];

  return (
    <>
      {/* <HeadingWithCreateBtn
        icon={<AiOutlinePlus size={20} />}
        btnTxt="create employee"
        title="Employee"
        onClick={handleModal}
      />
      <Search placeholder="search employee" query={query} setQuery={setQuery} /> */}
      <div className="flex items-center justify-between ">
        <Search
          placeholder="search employee"
          query={query}
          setQuery={setQuery}
        />
        <Button
          text={'Add employee'}
          variant="primary"
          onClick={handleAddModal}
          icon={<AiOutlinePlus size={20} />}
        />
      </div>

      <Table
        loading={isLoading}
        tableColumn={tableColumn}
        tableData={searchEmployeeData}
      />
      <AddEmployee
        generateRandomDigits={generateRandomDigits}
        token={token}
        // onClick={onClick}
        setIsHidden={setIsHidden}
        isHidden={isHidden}
        editEmployeeData={editEmployeeData}
        handleModal={handleModal}
        showModal={showModal}
        editId={editId}
        isEdit={isEdit}
        setEditId={setEditId}
        setIsEdit={setIsEdit}
      />
    </>
  );
};

export default React.memo(EmployeeList);
